import { loadStripe } from "@stripe/stripe-js";

let stripeInstance = null;

export const getStripeInstance = async (publishKey) => {
  if (!stripeInstance) {
    try {
      stripeInstance = await loadStripe(publishKey, {
        betas: ["server_side_confirmation_beta_1"],
        apiVersion: "2020-03-02;server_side_confirmation_beta=v1",
      });
    } catch (error) {
      throw error;
    }
  }

  return stripeInstance;
};